import React, { useState } from "react";
import { Avatar, Popover } from "antd";
import { momentit } from "../../utils";
import { ReactComponent as ViewIcon } from "../../Icons/totalView.svg";
import { useSelector } from "react-redux";
import { ReactComponent as InternalIcon } from "../../Icons/internal.svg";
import { ReactComponent as DownloadIcon } from "../../Icons/download.svg";
import Button2 from "../Button2/Button2";
import AttachmentBox from "../AttachmentBox/AttachmentBox";
// import TooltipComp from '../../ToolTip/TooltipComp';
import { ReactComponent as StarIcon } from "../../Icons/darkstar.svg";
import { getExpertsProfilePics } from "../../API/api";
export default function AnsweredByOtherNameInfo({ data,uuidVal}) {
  // console.log(data.expertUuid,'check check check')
  // React.useEffect(()=>{
  //   if(uuidVal.length>0){
  //       getExpertsProfilePics(uuidVal, undefined);
  //   }
  // },[])
  const searchState = useSelector((state) => state.search);
   const [isStapled, setIsStapled] = useState(false);
  const userState = useSelector((state) => state.user);
  const onCLickFavorite = () => {
  };
  const userProfile = () => {
    let img = "";
    // console.log("suers",searchState.usersProfilePicData,data.expertUuid)
    img = searchState.usersProfilePicData.find(
      (obj) => obj.uuid === data.expertUuid
    );
    if (img !== undefined) {
      return `data:image/JPEG;base64,${img.img}`;
    }
    // console.log("img",img)
  };
  // console.log("profile data", searchState.usersProfilePicData)
  userProfile();
  const infoContainer = {
    display: "flex",
    alignItems: "center",
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "7px",
  };
  const textStyles = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "500",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const dateStyles = {
    fontSize: "13px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };

  const renderAttachemnt = (arr) => {
    return (
      <div>
          {arr.map((item, index) => (
            <div className="mb-1">
              {" "}
              <AttachmentBox key={index} attachment={item} />
            </div>
          ))}
      </div>
    );
  };

  console.log("data file",data.expertScore)
  
  return (
    <>
      <div style={infoContainer}>
        <div>
          {/* {data.docType === "expertqa" && (
            <Avatar
              size={48}
              src={userProfile() || require("../../Images/cliente.png")}
            ></Avatar>
          )}
          {data.docType !== "expertqa" && (
            <Avatar
              size={48}
              src={require("../../Images/bot-icon.png")}
            ></Avatar>
          )} */}
       <Avatar
              size={48}
              src={userProfile() || require("../../Images/cliente.png")}
            ></Avatar>
        </div>
        <div style={dateInfoStyles}>
          <div>
            {/* {data.docType === "expertqa" && (
              <div style={textStyles}>
                {data.expertFirstName} {data.expertLastName}&nbsp;<span style={{fontSize:'16px'}}><StarIcon style={{marginBottom:'6px'}} />&nbsp;{Math.round(data.expertScore)}<span style={{fontWeight:'300'}}>/10</span></span>
              </div>
            )} */}
            {/* {data.docType !== "expertqa" && (
              <div style={textStyles}>
                {data.docName === "" || data.docName === undefined
                  ? `${data.expertFirstName} ${data.expertLastName}`
                  : data.docName} &nbsp;<span style={{fontSize:'16px'}}><StarIcon style={{marginBottom:'6px'}} />&nbsp;{Math.round(data.expertScore)}<span style={{fontWeight:'300'}}>/10</span></span>
              </div>
            )} */}
             <div style={textStyles}>
                {data.expertFirstName} {data.expertLastName}&nbsp;
                {
                  data.expertScore!==undefined&&   <span style={{fontSize:'16px'}}>
                  <StarIcon style={{marginBottom:'6px'}} />&nbsp;{Math.round(data?.expertScore)}<span style={{fontWeight:'300'}}>/10</span></span>
                }
             
              </div>
            <div style={dateStyles}>
              {data.answeredTimestamp < data.lastUpdatedTimestamp
                ? "Last reviewed"
                : "Answered"}
              &nbsp;
              {momentit(
                data.answeredTimestamp < data.lastUpdatedTimestamp
                  ? data.lastUpdatedTimestamp
                  : data.answeredTimestamp
              )}
            </div>
          </div>
          <div style={infoContainer}>
            {data.popularityScore !== null &&
              data.popularityScore !== undefined && (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    lineHeight: "24px",
                    color: "#5C667B",
                    fontWeight: "500",
                  }}
                >
                  <ViewIcon />
                  &nbsp;{data.popularityScore}&nbsp;&nbsp;
                </span>
                
              )}
                
            { data.internal && (
              <div style={{ marginRight: "6px" }}>
                <InternalIcon />
              </div>
            )}
            {
              data.attachments &&
              data.attachments.length > 0 && (
                <div style={{  }}>
                  <Popover title={renderAttachemnt(data.attachments)}>
                    {" "}
                    <Button2 onClickFunc={onCLickFavorite}>
                      <DownloadIcon />
                    </Button2>
                  </Popover>
                </div>
              )}
         

          </div>
        </div>
      </div>
    </>
  );
}
